import {TypeRoom} from '../common/constants';
import {getRandomColor} from '../common/helper';

export class RoomSetting {
  public color: string;
  public id: number;
  public r_name: string;
  public r_size: number;
  public peripheral_flag: number;
  public type_room: TypeRoom;
  public site_id: any;
  public site_name: string;

  constructor(id?: number, r_name?: string, r_size?: number, color?: string, peripheral_flag?: number, type_room?: TypeRoom,
               site_id?: number, site_name?: string) {
    this.id = id;
    this.r_name = r_name;
    this.r_size = r_size;
    this.color = color ? color : getRandomColor();
    this.peripheral_flag = peripheral_flag ? peripheral_flag : 0;
    this.type_room = type_room ? type_room : 0;
    this.site_id = site_id ? site_id : '';
    this.site_name = site_name ? site_name : '';
  }
}



// WEBPACK FOOTER //
// /app/src/app/models/room-setting.ts